import classnames from 'classnames'
import React from 'react'
import { useRef } from 'react'
import { useEffect } from 'react'

import * as styles from './trustpilot.module.scss'

interface Props {
  direction?: 'horizontal' | 'vertical'
  theme?: 'light' | 'dark'
}

export const Trustpilot: React.FC<Props> = ({
  direction = 'horizontal',
  theme = 'light',
}) => {
  const ref = useRef(null)

  useEffect(() => {
    if (window && (window as any).Trustpilot) {
      ;(window as any).Trustpilot.loadFromElement(ref.current, true)
    }
  }, [ref.current])

  return (
    <div
      ref={ref}
      className={classnames('trustpilot-widget', styles.trustbox, {
        [styles.trustboxHorizontal]: direction === 'horizontal',
        [styles.trustboxDark]: theme === 'dark',
      })}
      data-locale="en-GB"
      data-template-id={
        direction === 'horizontal'
          ? '5419b6ffb0d04a076446a9af'
          : '53aa8807dec7e10d38f59f32'
      }
      data-businessunit-id="548b605000006400057c1eff"
      data-style-height={direction === 'horizontal' ? '45px' : '120px'}
      data-style-width={direction === 'horizontal' ? '200px' : '200px'}
      data-theme={theme}
      data-stars="5"
    >
      <a
        href="https://uk.trustpilot.com/review/www.stockopedia.com"
        target="_blank"
        rel="noopener"
      >
        Trustpilot
      </a>
    </div>
  )
}
